import {
	GetSiteLocationsBasicDocument,
	type GetSiteLocationsBasicQuery,
	type GetSiteLocationsBasicQueryVariables
} from "~/gql/queries/siteLocation.generated";
import injectionBase from "~/services/endpoints/injectionBase";

const siteSelectApi = injectionBase.injectEndpoints({
	endpoints: (build) => ({
		GetSiteLocationsBasic: build.query<GetSiteLocationsBasicQuery, GetSiteLocationsBasicQueryVariables | void>({
			providesTags: ["SiteLocation"],
			query: (variables) => ({ document: GetSiteLocationsBasicDocument, variables })
		})
	}),
	overrideExisting: true
});

export const { useGetSiteLocationsBasicQuery } = siteSelectApi;

export default siteSelectApi;
